<template>
    <div>
    <div>
        <button class="ds-btn" :key="'reallyGen'" :disabled="!selectedUserCount" 
        :class="{'ds-btn--disabled': !selectedUserCount}" 
        @click.prevent="$bvModal.show('modal-generate-ovp')">Ģenerēt OVP formas</button>
    </div>

    <b-modal id='modal-generate-ovp'
             title="Ģenerēt OVP formas"
             @ok="handleOvpFormGenerate"
             ok-title="Ģenerēt"
             :ok-disabled="this.$parent.flags.invalid"
             cancel-title="Atcelt"
             size="xl"
             >
        <label class="d-block text-secondary text-left mb-0">Parakstītājs</label>
        <b-form-select id="manger" v-model="selectedManager" :options="companyManagersOptions"/>
        <div v-if="!selectedManager">
            <ValidationProvider rules="required" v-slot="{errors}" :customMessages="{required: 'Lauku Vārds jāaizpilda pbligāti.'}">
                <label class="d-block text-secondary text-left mb-0">Vārds</label>
                <input type="text" id="name" class="w-100 py-1 ds-input" v-model="customManager.name">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors}" :customMessages="{required: 'Lauku Uzvārds jāaizpilda obligāti.'}">
                <label class="d-block text-secondary text-left mb-0">Uzvārds</label>
                <input type="text" id="surname" class="w-100 py-1 ds-input" v-model="customManager.surname">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors}" :customMessages="{required: 'Lauku Amats jāaizpilda pbligāti.'}">
                <label class="d-block text-secondary text-left mb-0">Amats</label>
                <input type="text" id="jobTitle" class="w-100 py-1 ds-input" v-model="customManager.jobTitle">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <b-table 
            :fields="userFields" 
            :items="selectedUserItems" 
            :key="'modal-user-list'"
            sort-compare-locale="lv"
            :sort-by="'surname'"
            :sort-desc="false"
            sort-icon-left
            no-sort-reset
            small>
            <template #cell(actions)="row">
                <button class="ds-btn ds-btn--danger" @click.prevent="() => deselectUser(row.item.userId)" v-b-tooltip.hover.viewport title="Noņemt"><font-awesome-icon icon="user-minus"/></button>
            </template>
        </b-table>
    </b-modal>
</div>
</template>
<script>
    import {mapActions, mapMutations, mapGetters} from 'vuex';
   
    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';
import { ValidationProvider } from 'vee-validate';

    export default {
        name: 'users-ovp-job-conditions-generate',
        components: { ValidationProvider },
        data: () => ({
            isModalVisible: false,
            selectedManager: null,
            customManager: {
                name: null,
                surname: null,
                jobTitle: null
            },
            userFields: [
                {
                key: 'name',
                label: 'Vārds', sortable: true
            },    {
                key: 'surname',
                label: 'Uzvārds'
                , sortable: true
            },
            { key: 'jobTitle',
              label: 'Amats'
              , sortable: true
            },
            { key: 'actions',
              label: ''
            }
        ]
                }),
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
                companyManagers: companyStoreTypes.GET_CURRENT_COMPANY_MANAGERS
            }),
            ...mapGetters('ovp', {
                 /** @type {function|*} */
                selectedUsers: ovpStoreTypes.GET_SELECTED_OVP_USERS,
            }),
            companyManagersOptions() {
                 const temp = this.companyManagers.map(({_id, name, surname}) => ({ value: _id, text: `${name} ${surname}`}))
                 temp.push({value: null, text: "Cits..."})
                 return temp
            },
            selectedUserCount() {
                return Object.keys(this.selectedUsers).length
            },
            selectedUserItems() {
                return Object.values(this.selectedUsers)
            }
        },
        watch: {
            companyManagersOptions(newCompanyManages) {
                this.selectedManager = newCompanyManages[0].value
            },
            selectedUsers(newSelectedUsers) {
                if (Object.keys(newSelectedUsers).length === 0) {
                    this.$bvModal.hide('modal-generate-ovp')
                }
            }
        },
        methods: {
            ...mapActions('ovp', {
                /** @type {function|*} */
                generateOvpForms:  ovpStoreTypes.ACTION_GENERATE_OVP_FORMS,
            }),
            ...mapMutations('ovp', {
                /** @type {function|*} */
                unsetSelectedUsers: ovpStoreTypes.UNSET_SELECTED_OVP_USERS,
            }),
            deselectUser(what)  {
                this.$root.$emit('opv:user:deselect', what)

            },
            async handleOvpFormGenerate(modalEvent) {

                modalEvent.preventDefault()
                const isValid = await this.$parent.validate();

                if (!isValid || !Object.values(this.selectedUsers).length) {
                    return;
                }

                try {
                     //For template categories currentCompany._id will be empty
                    await this.generateOvpForms({companyId: this.currentCompany._id,
                                                selectedUsers: this.selectedUsers,
                                                selectedManager: this.selectedManager,
                                                customManager: this.customManager});
                    this.$bvModal.hide('modal-generate-ovp')
                    this.$parent.reset();
                    this.$root.$emit('ovp:user:clearSelection')
                } catch (error) {
                    this.$parent.setErrors({[error.field]: [error.message]});
                }
            }
        },
    }
</script>